module.exports = __webpack_public_path__ + "static/media/8766.738b5f27.png";